import { Injectable } from '@angular/core';
import { MakeCallService } from '../services/makecall.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PhpConfigService {

  constructor(private makeCall: MakeCallService) { }

  getKeyConfigValue(key: string): Observable<any> {
    return this.makeCall.getCall('phpConfig/keyConfigValue', { key: key });
  }
}
